import React from 'react'
import classes from '@src/styles/PitchLeft.module.css'
import classNames from 'classnames'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { COMPANY_CREDENTIALS } from '@src/constants/credentials'
// import TrustBox from '../../../shared/components/TrustPilot'

const HeroText = () => (
  <h3 className={classes.heroText}>
    About
    <br /> Dimension
  </h3>
)

const SubText = () => {
  const router = useRouter();
  const { gclid } = router.query;
  return (
    <>
      <p className={classes.subText}>
        Dimension is the first tech-enabled service to radically simplify waste management for
        companies of any size, nationwide.
      </p>
      <p className={classes.subText}>
        Our solutions are customizable and on-demand, as perfectly suited to solving ad hoc or
        emergency issues as they are to dealing with regular pick-ups.
      </p>
      <p className={classes.subText}>
        Dimension is a registered motor carrier (USDOT {COMPANY_CREDENTIALS.usdot}) and an
        EPA-registered hazardous waste transporter (EPA ID {COMPANY_CREDENTIALS.epaId}).
      </p>
      <div className={classes.buttonContainer}>
        <Link href={`${process.env.NEXT_PUBLIC_REDIRECT_URL}booking?step=initial&redirect=1&gclid=${gclid ?? ""}`} className={classes.primaryButton}>
          Try Dimension
        </Link>
      </div>
    </>
  )
}

function Pitch() {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classNames(classes.leftPane, classes.highLeft)}>
          <div className={classes.pitchContent}>
            <HeroText />
            <SubText />
            {/* <TrustBox style="landing-widget" /> */}
          </div>
        </div>
        <div className={classNames(classes.rightPane, classes.aboutUs)} />
      </div>
    </div>
  )
}
export default Pitch
